import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { IoMdClose, IoMdInformationCircleOutline } from "react-icons/io";
import ReactInputMask from "react-input-mask";
import { object, string } from "yup";

import RequestingService from "../../../../services/requesting.service";
import { regexEmail } from "../../../../utils/utils";
import { Input } from "../../../Input";
import { useMutation, useQueryClient } from "react-query";
import { NotificationFields } from "../../../../types/notification";

interface RequesterModalProps {
  isOpen: boolean;
  editClient: any;
  onClose: () => void;
}

const schema = object({
  name: string().required("Nome é obrigatório"),
  email: string().matches(regexEmail).required("Email é obrigatório"),
  phone: string().min(14).required("Telefone é obrigatório"),
}).required();

const CreateRequesterModal = ({
  isOpen,
  editClient,
  onClose,
}: RequesterModalProps) => {
  const {
    register,
    handleSubmit,
    watch,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      email: "",
      phone: undefined,
    },
    resolver: yupResolver(schema),
    mode: "all",
  });

  const [notification, setNotification] = useState<NotificationFields>({
    open: false,
    severity: "success",
    message: "",
  });
  function closeNotification() {
    setNotification({ ...notification, open: false });
  }

  const queryClient = useQueryClient();

  const handleCloseDialog = () => {
    reset();
    onClose();
  };

  async function onSubmit(form: any) {
    createRequester({
      ...form,
      client: editClient?._id,
    });
  }

  const { mutate: createRequester, isLoading: isLoadingCreate } = useMutation(
    (state: any) => RequestingService.create(state),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("requesters-data");
        handleCloseDialog();
      },
      onError: (error) => {
        setNotification({
          open: true,
          severity: "error",
          message: "Não foi possível criar",
        });
      },
    }
  );

  return (
    <Dialog onClose={handleCloseDialog} open={isOpen} fullWidth maxWidth={"sm"}>
      <DialogTitle sx={{ m: 0, paddingTop: 3, color: "#4B465C", fontSize: 24 }}>
        Cadastrar novo Solicitante
      </DialogTitle>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          backgroundColor: "#E8F2FC",
          margin: "8px 26px",
          borderRadius: 2,
          padding: "20px 18px",
          alignItems: "center",
          gap: 2,
        }}
      >
        <IoMdInformationCircleOutline color="#1976D2" />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: 14 }}>
            1. Não abrevie nomes para evitar homônimos
          </span>
          <span style={{ fontSize: 14 }}>
            2. Email com domínio de empresa se possível
          </span>
        </div>
      </Box>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 16,
          top: 16,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <IoMdClose />
      </IconButton>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent sx={{ px: 3.5 }}>
          <Box display={"flex"} flexDirection={"column"}>
            <Input label="Nome" {...register("name")} error={!!errors.name} />

            <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
              <Input
                label="Email"
                {...register("email")}
                error={!!errors.email}
                placeholder="nome@empresa.com"
              />

              <Controller
                control={control}
                name="phone"
                render={({ field: { onChange, onBlur, ref } }) => (
                  <ReactInputMask
                    // @ts-ignore
                    maskPlaceholder={null}
                    mask="(99) 99999-9999"
                    onChange={onChange}
                    onBlur={onBlur}
                    inputRef={ref}
                  >
                    <Input
                      label="Telefone"
                      placeholder="(00) 0 0000 0000"
                      error={!!errors.phone}
                    />
                  </ReactInputMask>
                )}
              />
            </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 4, py: 3 }}>
          <Button
            type="button"
            variant="outlined"
            onClick={handleCloseDialog}
            sx={{ fontSize: 16, color: "#1361A4" }}
          >
            Cancelar
          </Button>

          <Button
            type="submit"
            onClick={handleSubmit(onSubmit)}
            disabled={isLoadingCreate}
            sx={{ fontSize: 16, backgroundColor: "#1361A4" }}
          >
            Cadastrar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateRequesterModal;
